import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MinimalTeam } from 'src/services/tournaments/getMinimalTeams';
import { TournamentOptions } from 'src/services/tournaments/getOptions';
import { TournamentDetailsData } from 'src/services/tournaments/getTournamentDetails';
import { Tournament } from 'src/services/tournaments/getTournaments';
import { TournamentScheduleReponse } from 'src/services/tournaments/getTournamentSchedule';
import { MinimalTournament } from 'src/services/tournaments/getTournamentsWithoutPagination';

interface StateType {
  selectedTournament: TournamentDetailsData | undefined;
  tournaments: Tournament[];
  meta: any;
  options: TournamentOptions;
  tournamentSchedule: TournamentScheduleReponse | undefined;
  minimalTeams: MinimalTeam[] | undefined;
  minimalTournaments: MinimalTournament[] | undefined;
}

const initialState: StateType = {
  selectedTournament: undefined,
  tournaments: [],
  options: {
    data: {
      ranks: [],
      rank_types: [],
      tournament_categories: [],
      interface_types: { '1': 'NORMAL' },
      tournament_types: [],
      sport_types: [],
    },
  },
  meta: undefined,
  tournamentSchedule: undefined,
  minimalTeams: undefined,
  minimalTournaments: undefined,
};

export const TournamentSlice = createSlice({
  name: 'Tournament',
  initialState,
  reducers: {
    setSelectedTournament: (state, action: PayloadAction<TournamentDetailsData>) => {
      state.selectedTournament = action.payload;
    },
    setTournaments: (state, action: PayloadAction<Tournament[]>) => {
      state.tournaments = action.payload;
    },
    setMeta: (state, action: PayloadAction<any>) => {
      state.meta = action.payload;
    },
    setOptions: (state, action: PayloadAction<TournamentOptions>) => {
      state.options = action.payload;
    },
    setTournamentSchedule: (state, action: PayloadAction<TournamentScheduleReponse>) => {
      state.tournamentSchedule = action.payload;
    },
    setMinimalTeams: (state, action: PayloadAction<MinimalTeam[]>) => {
      state.minimalTeams = action.payload;
    },
    setMinimalTournaments: (state, action: PayloadAction<MinimalTournament[]>) => {
      state.minimalTournaments = action.payload;
    },
  },
});

export const {
  setSelectedTournament,
  setTournaments,
  setMeta,
  setOptions,
  setTournamentSchedule,
  setMinimalTeams,
  setMinimalTournaments,
} = TournamentSlice.actions;

export default TournamentSlice.reducer;
